import HeaderPortal from "components/portal/header-portal";
import { Button } from "ui/components/button";
import CreateItemButton from "components/buttons/create";
import EmployeeInput from "components/employee/input";
import { PermissionGate } from "permissions/components/gate";
import React from "react";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useCreateSelfNomination } from "./mutation";
import { useSelector } from "react-redux";
import { selectUser } from "store";
import {
  getHigherGradesFromGrade,
  getHigherGradesFromRoleName,
} from "utils/role-hierarchy";
import { eventBus } from "utils/eventBus";
import { useQuad } from "@/modules/performance/context";

const SelfNominationInputSheet = ({ reviews }) => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const { quad } = useQuad();

  const { quadId } = useParams();
  const { mutate: createSelfNomination } = useCreateSelfNomination({
    onSuccess: () => {
      setSelectedEmployee(null);
      if (quadId) {
        const refreshKey = `performance_reviewperformance_feedbacks-${quadId}`;
        eventBus.emit("refresh:list", refreshKey);
      }
    },
  });

  const user = useSelector(selectUser);

  const eligibleGrades = getHigherGradesFromGrade(user.grade?.name);
  const hasSelfNominated = reviews?.some((review) => review.self_nominated);

  const handleConfirm = () => {
    if (selectedEmployee && quadId) {
      createSelfNomination({
        quadId,
        employeeIds: [selectedEmployee.id],
      });
    }
  };

  function renderFooter({ selectedEmployees, setOpen, setSelectedEmployee }) {
    return (
      <Button
        onClick={() => {
          handleConfirm();
          setSelectedEmployee(null);
          setOpen(false);
        }}
        disabled={selectedEmployees.length === 0}
      >
        Select
      </Button>
    );
  }

  if (hasSelfNominated || quad?.status === "completed") {
    return null;
  }

  return (
    <>
      <EmployeeInput
        singleSelect={true}
        value={selectedEmployee}
        onChange={setSelectedEmployee}
        allowRemoval={true}
        footer={renderFooter}
        enableStateManager={false}
        filters={{ grade: { _in: eligibleGrades || [] } }}
        excludedEmployeeIds={[
          ...(reviews?.map((item) => item.reviewer?.id || item.reviewer) || []),
          ...(selectedEmployee ? [selectedEmployee.id] : []),
          user.id,
        ]}
      >
        <HeaderPortal>
          <PermissionGate
            rule="create:*"
            collection="performance_review"
            showWhenDisabled={false}
          >
            <CreateItemButton>Nominate</CreateItemButton>
          </PermissionGate>
        </HeaderPortal>
      </EmployeeInput>
    </>
  );
};

export default SelfNominationInputSheet;
